import { render, staticRenderFns } from "./RelatorioGestaoPcaRolResponsaveis.vue?vue&type=template&id=919c599e"
import script from "./RelatorioGestaoPcaRolResponsaveis.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaRolResponsaveis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports